export function BrandedLoadingState({ label = 'Preparing your account…' }: { label?: string }) {
  return (
    <div className="route-loading" role="status">
      <span className="wordmark__mark" aria-hidden="true">
        E
      </span>
      <span>{label}</span>
    </div>
  );
}
